export enum AxiosCodeEnum {
  SUCCESS = 200,
  CREATED = 200,
  BAD_REQUEST = 400,
}

export enum HTTPResStatusCodeEnum {
  ACTIVE_SESSION = 402,
  ECONNABORTED = 'ECONNABORTED',
  ERR_NETWORK = 'ERR_NETWORK',
  ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE',
}
